import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { formatMessage as t } from '../../../../../utils/language';
import messages from '../../../../../utils/translationMessages';
import './light.css';
import './styles.css';

class FilterHeaderContainer extends PureComponent {
  render() {
    return (
      <div className="filter-header-container">
        <div className={classnames('filter-header', { sticky: this.props.sticky, [`filter-header-${this.props.type}`]: this.props.type } ) }>
          {this.props.children}
        </div>
      </div>
    );
  }
}

FilterHeaderContainer.propTypes = {
  children: PropTypes.node,
  sticky: PropTypes.bool,
  type: PropTypes.string,
};

class FilterButton extends PureComponent {
  render() {
    return (
      <button className="filter-button" onClick={this.props.onClick}>
        {t(messages.filter)}
        <span className="count">{this.props.count}</span>
      </button>
    );
  }
}

FilterButton.propTypes = {
  count: PropTypes.number,
  onClick: PropTypes.func,
};

export {
  FilterHeaderContainer,
  FilterButton
};
